import { render, staticRenderFns } from "./newContact.vue?vue&type=template&id=366a1e07&scoped=true"
import script from "./newContact.vue?vue&type=script&lang=js"
export * from "./newContact.vue?vue&type=script&lang=js"
import style0 from "./newContact.vue?vue&type=style&index=0&id=366a1e07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a1e07",
  null
  
)

export default component.exports